// The grounds at night: fireflies scatter by default, but they know where your
// people are standing. Presentation only — no server, no wire.

export const DEFAULT_SPOTS = [
  { x: 300, y: 300 }, { x: 470, y: 250 }, { x: 620, y: 320 },
  { x: 200, y: 350 }, { x: 740, y: 290 }
]

export const FIREFLY_COUNT = DEFAULT_SPOTS.length

export function gathersForKith(kithVenues) {
  return Array.isArray(kithVenues) && kithVenues.length > 0
}

export function nightEnough(phase) {
  return phase === "dusk" || phase === "night"
}

// Where each firefly belongs: scattered by day, or drifting toward a kith venue
// after dark. Returns start position and the home it eases toward.
export function fireflyAnchors(kithVenues, venueSpots) {
  if (!gathersForKith(kithVenues)) {
    return DEFAULT_SPOTS.map((spot) => ({ x: spot.x, y: spot.y, home: spot }))
  }

  return DEFAULT_SPOTS.map((spot, i) => {
    const venue = kithVenues[i % kithVenues.length]
    const anchor = venueSpots[venue]
    if (!anchor) return { x: spot.x, y: spot.y, home: spot }

    const jitterX = ((i * 37) % 50) - 25
    const jitterY = -30 - ((i * 53) % 28)
    const home = { x: anchor.cx + jitterX, y: anchor.cy + jitterY }

    return { x: spot.x, y: spot.y, home }
  })
}
